import { useTranslate } from 'ra-core';
import { AutocompleteArrayInput } from '../../components/admin/autocomplete-array-input';
import { DateInput } from '../../components/admin/date-input';
import { ReferenceArrayInput } from '../../components/admin/reference-array-input';
import { cn } from '../../lib/utils';
import { filterAutocompleteClassName } from '../Moonstar/filterClasses';

const TopicFilterInput = () => {
  const translate = useTranslate();
  return (
    <AutocompleteArrayInput
      optionText="displayName"
      placeholder={translate('resources.posts.filters.allTopics')}
      className={cn(filterAutocompleteClassName, 'w-64 [&_input]:text-sm')}
      filterToQuery={(q: string) => ({ displayName: q })}
    />
  );
};

export const PostFilters = [
  <ReferenceArrayInput
    key="topicId"
    source="topicId"
    reference="topics"
    perPage={999}
    sort={{ field: 'displayName', order: 'ASC' }}
    alwaysOn
  >
    <TopicFilterInput />
  </ReferenceArrayInput>,
  <DateInput key="createdAfter" source="createdAfter" />,
  <DateInput key="createdBefore" source="createdBefore" />,
];
